import React from 'react';
import PropTypes from 'prop-types';

function Egg({ articles, score = -1 }) {
  let articleElements = articles
    .filter((article) => article.selected)
    .map((article) => {
      const id = article.id;
      const imagePath = require(`../asset/img/${id}.png`);
      return <img src={imagePath} alt={id} key={id} className={id} />;
    });

  let egg = 'egg';
  if (score < -1) egg = 'egg-singing';
  if (score > -1) {
    if (score > 50) egg = 'egg-happy';
    if (score < 50) egg = 'egg-sad';
    if (score === 0) egg = 'egg-angry';
    if (score === 100) egg = 'egg-happier';
    if (score === 101) egg = 'egg-bubbles';
    if (score === 102) egg = 'egg-awkward';
    if (score === 103) egg = 'egg-sour';
    if (score === 104) egg = 'egg-sweat';
    if (score === 105) {
      egg = 'egg-crack';
      articleElements = [];
    }
  }
  return (
    <div className="egg">
      <img src={require(`../asset/img/${egg}.png`)} alt="egg" className={egg} />
      {articleElements}
    </div>
  );
}

Egg.propTypes = {
  articles: PropTypes.array.isRequired,
  score: PropTypes.number
};

export default Egg;
